import { z } from "zod";

export const posthogBootstrapDataSchema = z.object({
  distinctID: z.string().optional(),
  featureFlags: z
    .record(z.string(), z.union([z.boolean(), z.string()]))
    .optional(),
});

// Geo data derived server-side from Vercel's x-vercel-ip-* request headers.
// Returned by /api/geo and attached to cookieless PostHog events as $geoip_*
// properties (PostHog's GeoIP transformation cannot run for cookieless events
// because the IP is stripped before ingestion transformations).
export const vercelGeoSchema = z.object({
  countryCode: z.string(),
  countryName: z.string().nullable(),
  continentCode: z.string().nullable(),
  continentName: z.string().nullable(),
  cityName: z.string().nullable(),
  subdivisionCode: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  timeZone: z.string().nullable(),
  postalCode: z.string().nullable(),
});

export type VercelGeo = z.infer<typeof vercelGeoSchema>;
